// Constants should be defined first to avoid initialization order issues
export const UPDATE_SESSION = 'UPDATE_SESSION'
export const SET_ONBOARDING_REQUIRED = 'SET_ONBOARDING_REQUIRED'
export const SET_SKIPPED_ONBOARDING = 'SET_SKIPPED_ONBOARDING'

// Then define enums
export enum AccessLevel {
  User = 'USER',
  Admin = 'ADMIN',
}

// Then interfaces
export interface ICredentials {
  temporaryAccessToken?: string
  refreshToken?: string
  accessToken?: string
}

export interface ISessionState {
  isAuthenticated: boolean
  userId: string
  accessLevel: AccessLevel
  sessionInvalidated: boolean
  onboardingRequired: boolean
  skippedOnboarding: boolean
  accessToken?: string
  refreshToken?: string
}

interface IUpdateSessionAction {
  type: typeof UPDATE_SESSION
  payload: ISessionState
}

interface ISetOnboardingRequiredAction {
  type: typeof SET_ONBOARDING_REQUIRED
  payload: { onboardingRequired: boolean }
}

interface ISetSkippedOnboardingAction {
  type: typeof SET_SKIPPED_ONBOARDING
  payload: { skippedOnboarding: boolean }
}

export type SessionActionTypes =
  | IUpdateSessionAction
  | ISetOnboardingRequiredAction
  | ISetSkippedOnboardingAction
